import { useLingui } from "@lingui/react";
import { Trans } from "@lingui/react/macro";
import { ArrowRightIcon } from "@phosphor-icons/react";
import { createFileRoute, Link } from "@tanstack/react-router";

import { Button } from "@/components/ui/button";

import { getHomeMetadata } from "./-metadata";
import { getHomePrimaryCta, getHomeSecondaryCta } from "./-navigation";
import { Footer } from "./-sections/footer";
import { HomeWorkflow, homeWorkflowMessages } from "./-sections/home-workflow";

export const Route = createFileRoute("/_home/")({
  component: RouteComponent,
  head: () => {
    const metadata = getHomeMetadata();

    return {
      meta: [
        { title: metadata.title },
        { name: "description", content: metadata.description },
        { property: "og:title", content: metadata.title },
        { property: "og:description", content: metadata.description },
        { property: "twitter:title", content: metadata.title },
        { property: "twitter:description", content: metadata.description },
      ],
    };
  },
});

function RouteComponent() {
  const { i18n } = useLingui();
  const { session } = Route.useRouteContext();
  const primaryCta = getHomePrimaryCta(session);
  const secondaryCta = getHomeSecondaryCta(session);

  return (
    <main id="main-content" className="relative min-h-svh pt-20">
      <section
        className="container mx-auto space-y-8 px-4 py-10 sm:px-6 lg:px-12 lg:py-16"
        data-phase6-state="homepage-value-proposition"
      >
        <div className="max-w-3xl space-y-4">
          <p className="text-sm font-medium text-muted-foreground">
            <Trans>Invite-only beta</Trans>
          </p>
          <h1 className="text-4xl font-semibold tracking-tight text-balance sm:text-6xl">
            {i18n._(homeWorkflowMessages.title)}
          </h1>
          <p className="max-w-3xl text-base leading-relaxed text-muted-foreground sm:text-lg">
            {i18n._(homeWorkflowMessages.intro)}
          </p>
        </div>

        <div className="flex flex-wrap gap-3">
          <Button
            nativeButton={false}
            render={
              <Link to={primaryCta.to} data-phase6-entry={session ? "home-to-dashboard" : "home-to-registration"}>
                {i18n._(primaryCta.label)}
                <ArrowRightIcon />
              </Link>
            }
          />
          {secondaryCta ? (
            <Button
              variant="secondary"
              nativeButton={false}
              render={
                <Link to={secondaryCta.to} data-phase6-entry="home-to-login">
                  {i18n._(secondaryCta.label)}
                </Link>
              }
            />
          ) : null}
        </div>
      </section>

      <HomeWorkflow />

      <Footer />
    </main>
  );
}
